// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2y749","list":"BalanceDue_list__3-99V","listRow":"BalanceDue_listRow__23bQF","total":"BalanceDue_total__3b8zz"};